import {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import * as React from "react";
import LoadingSpinner from "../LoadingSpinner";
import {getBehalfOf} from "../../api/systemUserApi";
import SearchDropdown from "../input/SearchDropdown";
import {FORMS, MODULES} from "../../const";
import Input from "../input/Input";
import Button from "../input/Button";
import {getUserData} from "../../api/userApi";
import {useSelector} from "react-redux";
import {getUserProfileData} from "../../api/deviceRegistrationApi";
import {employeeValidation} from "../validations/EmployeeCreation";
import Dropdown from "../input/Dropdown";
import {getDropdownData} from "../../api/keyvalue";


const DeviceRegisterForm = forwardRef(
    (
        {
            style = {},
            positionStyle = {},
            value,
            heading = "Device Register",
            isLoading,
            showQrCloseButton = false,
            handleQRPopUpCloseChange = () => {},
            currentContactErrors,
        },
        ref
    ) =>{

        const [registerDeviceSMS, setRegisterDeviceSMS] = useState(
            {
                regUser:"",
                regUserName:"",
                regMobile:"",
                regEmail:"",
                regAlertType: "",
            }
        );
        const errorState = useSelector((state) => state.error.deviceCurrentActionErrors);

        const user = useSelector((state) => state.user);

        // flags
        const [searchFieldReset, setSearchFieldReset] = useState(false);
        const [userFieldReset, setUserFieldReset] = useState(false);

        //dropdown
        const [notificationType, setNotificationType] = useState([]);

        const [currentErrors, setCurrentErrors] = useState({});
        useEffect(() => {
            setCurrentErrors(currentContactErrors);
        }, [currentContactErrors]);

        useEffect(() => {
            (async () => {

                const alertData = await getDropdownData("alert_type");
                const alertType = alertData.filter(item => [3, 4].includes(item.key));
                setNotificationType(alertType);
            })();
        }, []);

        const getUserData = async (data) =>{
            const response = await getUserProfileData({
                userId: data,
                userCode: '-2'
            })
            setRegisterDeviceSMS((prevState) => ({
                ...prevState,
                regUser: data,
                regMobile: response?.data.profile.contactNo,
                regEmail: response?.data.profile.email
            }));

            if (response?.data.profile.contactNo){

                setCurrentErrors((prevState) => {
                    const { regMobile: _, ...rest } = prevState;
                    return rest;
                })

            }
        }

        useImperativeHandle(ref, () => ({
            getData: () => registerDeviceSMS,
            reset: () =>{
                setRegisterDeviceSMS({
                    regUser:"",
                    regUserName:"",
                    regMobile:"",
                    regAlertType: ""
                });
                setUserFieldReset(true);
            }
        }));

        return(
            <>
                <div
                    style={{
                        ...positionStyle,
                        padding: "10px 10px 10px 0",
                        justifyContent: "space-between",
                    }}
                >
                    {heading && <h3 style={{marginBottom: "10px"}}>{heading}</h3>}
                    <div style={{display: "flex", gap: "5px"}}>
                        {showQrCloseButton && (
                            <button
                                className="ui primary right floated button"
                                type="button"
                                onClick={(e) => {
                                    handleQRPopUpCloseChange()
                                }}
                                style={{display: "flex", alignItems: "center"}}
                            >
                                <div style={{display: "flex", alignItems: "center"}}>
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        Close Form
                                    </div>
                                </div>
                            </button>
                        )}
                    </div>
                </div>
                {isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <form
                        className="ui form"
                         //style={{ height:"35vh"}}
                    >
                        <div className="ui segment"
                             style={{paddingBottom:"40px"}}
                        >
                            <div className="two fields">
                                <Dropdown
                                    label="Notification Type"
                                    options={notificationType}
                                    placeholder="Notification Type"
                                    style={{height: "20px"}}
                                    value={registerDeviceSMS.regAlertType}
                                    onChange={(e, data) => {
                                        setRegisterDeviceSMS((prevState) => ({
                                            ...prevState,
                                            regAlertType: data.value,
                                        }));
                                    }}
                                    error={currentErrors.regAlertType}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const { regAlertType: _, ...rest } = prevState;
                                            return rest;
                                        })
                                    }
                                    required={true}
                                />
                            </div>
                            <div className="two fields">
                                <SearchDropdown
                                    key={1}
                                    threshold={1}
                                    required={true}
                                    multiGrid={true}
                                    multiGridCurrentValue={registerDeviceSMS.regUserName}
                                    reset={userFieldReset}
                                    setReset={setUserFieldReset}
                                    api={getBehalfOf}
                                    apiDependency={{
                                        customer: null,
                                        shipper: null,
                                    }}
                                    onResultSelect={(data) => {
                                        getUserData(data);
                                    }
                                    }
                                    error={currentErrors.regUser}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {regUser: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    label="User"
                                    clearable={true}
                                />
                                {registerDeviceSMS.regAlertType === 3 ? (
                                <Input
                                    required={true}
                                    label="Mobile "
                                    name="regMobile"
                                    minLength={10}
                                    error={currentErrors.regMobile}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {regMobile: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    value={registerDeviceSMS.regMobile}
                                    onChange={(e) => {
                                        setRegisterDeviceSMS((prevState) => ({
                                            ...prevState,
                                            regMobile: e.target.value,
                                        }));
                                    }}
                                    disabled={true}
                                />
                                ): registerDeviceSMS.regAlertType === 4 ?(
                                <Input
                                    required={true}
                                    label="Email "
                                    name="regEmail"
                                    minLength={10}
                                    error={currentErrors.regEmail}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {regEmail: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    value={registerDeviceSMS.regEmail}
                                    onChange={(e) => {
                                        setRegisterDeviceSMS((prevState) => ({
                                            ...prevState,
                                            regEmail: e.target.value,
                                        }));
                                    }}
                                    disabled={true}
                                />
                                ):registerDeviceSMS.regAlertType === "" ? (
                                    <></>
                                ): null}
                            </div>
                        </div>
                    </form>
                )}
            </>
        )
    }
);

export default DeviceRegisterForm;
